<template>
	<div style="padding-top: 10px;">
		<a-card title="数据概览" style="width: 100%" size="small">
			<div slot="extra">
				<a-radio-group default-value="a" size="small">
					<a-radio-button value="a">今日</a-radio-button>
					<a-radio-button value="b">近7日</a-radio-button>
					<a-radio-button value="c">近30日</a-radio-button>
				</a-radio-group>
			</div>
			<a-row :gutter="16">
				<a-col :span="3">
					<a-statistic title="成交金额" :value="0">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="核销金额" :value="0">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="退款金额" :value="0">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="入园人数" :value="0">
						<template #suffix><span style="color: #7e868f;">人</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="订单总数" :value="0">
						<template #suffix><span style="color: #7e868f;">笔</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="核销金额" :value="0">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="核销金额" :value="0">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
				<a-col :span="3">
					<a-statistic title="退订张数" :value="0">
						<template #suffix><span style="color: #7e868f;">元</span></template>
					</a-statistic>
				</a-col>
			</a-row>
		</a-card>
		
		<div style="display: flex;margin-top: 10px;">
			<a-card title="票种销售分析" style="width:  calc(40% - 5px);margin-right: 10px;" size="small">
				<div id="pzfx" style="height: calc(100vh - 394px);width: 90%;"></div>
			</a-card>
			
			<a-card title="营业额趋势图" style="width:  calc(60% - 5px);" size="small">
				<div id="yyeqst" style="height: calc(100vh - 394px);width: 85%;"></div>
			</a-card>
		</div>
		<a-card title="系统公告" style="margin-top: 10px;height: 100px;" size="small">
			<div>暂无</div>
		</a-card>

		
		

	</div>

</template>
<script>
	import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
	export default {
		data() {
			return {
				staff: {
					staffAccount: window.sessionStorage.getItem('staffAccount')
				},

			};
		},
		methods: {
			pzfx() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById("pzfx"));
				// 指定图表的配置项和数据
				let option = {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center'
					},
					series: [{
						name: '票种销售分析',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
				  labelLine: {
							show: false
						},
						data: [{
								value: 1048,
								name: '测试门票(全价票)'
							},
				 		{
								value: 735,
								name: '测试门票(半价票)'
							},
							{
								value: 580,
								name: '测试车票(全价票)'
							},
							{
								value: 484,
								name: '测试车票(半价票)'
							},

						]
					}]
				};
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
			yyeqst() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById("yyeqst"));
				let option = {
				  color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
				  title: {
				    text: ''
				  },
				  tooltip: {
				    trigger: 'axis',
				    axisPointer: {
				      type: 'cross',
				      label: {
				        backgroundColor: '#6a7985'
				      }
				    }
				  },
				  legend: {
				    data: ['测试门票(全价票)', '测试门票(半价票)', '测试车票(全价票)', '测试车票(半价票)']
				  },
				  toolbox: {
				    feature: {
				      saveAsImage: {}
				    }
				  },
				  grid: {
				    left: '3%',
				    right: '4%',
				    bottom: '3%',
				    containLabel: true
				  },
				  xAxis: [
				    {
				      type: 'category',
				      boundaryGap: false,
				      data: ['2月13日', '2月14日', '2月15日', '2月16日', '2月17日', '2月18日', '2月19日']
				    }
				  ],
				  yAxis: [
				    {
				      type: 'value'
				    }
				  ],
				  series: [
				    {
				      name: '测试门票(全价票)',
				      type: 'line',
				      stack: 'Total',
				      smooth: true,
				      lineStyle: {
				        width: 0
				      },
				      showSymbol: false,
				      areaStyle: {
				        opacity: 0.8,
				        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				          {
				            offset: 0,
				            color: 'rgb(128, 255, 165)'
				          },
				          {
				            offset: 1,
				            color: 'rgb(1, 191, 236)'
				          }
				        ])
				      },
				      emphasis: {
				        focus: 'series'
				      },
				      data: [140, 232, 101, 264, 90, 340, 250]
				    },
				    {
				      name: '测试门票(半价票)',
				      type: 'line',
				      stack: 'Total',
				      smooth: true,
				      lineStyle: {
				        width: 0
				      },
				      showSymbol: false,
				      areaStyle: {
				        opacity: 0.8,
				        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				          {
				            offset: 0,
				            color: 'rgb(0, 221, 255)'
				          },
				          {
				            offset: 1,
				            color: 'rgb(77, 119, 255)'
				          }
				        ])
				      },
				      emphasis: {
				        focus: 'series'
				      },
				      data: [120, 282, 111, 234, 220, 340, 310]
				    },
				    {
				      name: '测试车票(全价票)',
				      type: 'line',
				      stack: 'Total',
				      smooth: true,
				      lineStyle: {
				        width: 0
				      },
				      showSymbol: false,
				      areaStyle: {
				        opacity: 0.8,
				        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				          {
				            offset: 0,
				            color: 'rgb(55, 162, 255)'
				          },
				          {
				            offset: 1,
				            color: 'rgb(116, 21, 219)'
				          }
				        ])
				      },
				      emphasis: {
				        focus: 'series'
				      },
				      data: [320, 132, 201, 334, 190, 130, 220]
				    },
				    {
				      name: '测试车票(半价票)',
				      type: 'line',
				      stack: 'Total',
				      smooth: true,
				      lineStyle: {
				        width: 0
				      },
				      showSymbol: false,
				      areaStyle: {
				        opacity: 0.8,
				        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				          {
				            offset: 0,
				            color: 'rgb(255, 0, 135)'
				          },
				          {
				            offset: 1,
				            color: 'rgb(135, 0, 157)'
				          }
				        ])
				      },
				      emphasis: {
				        focus: 'series'
				      },
				      data: [220, 402, 231, 134, 190, 230, 120]
				    },
				  ]
				}
				myChart.setOption(option);
			}

		},
		mounted() {
			this.pzfx()
			this.yyeqst()
		},
		created() {

		}
	};
</script>

<style lang="less">

</style>
